const topicsData = [
  { tag: '#咒术回战最新话', heat: '9.8万讨论', icon: 'ri-fire-line', accent: true },
  { tag: '#海贼王最终章', heat: '8.5万讨论', icon: 'ri-anchor-line', accent: true },
  { tag: '#间谍过家家剧场版', heat: '7.2万讨论', icon: 'ri-movie-line' },
  { tag: '#怪兽8号第二季', heat: '6.8万讨论', icon: 'ri-rocket-line' },
  { tag: '#胆大党动画化', heat: '5.4万讨论', icon: 'ri-ghost-line' },
  { tag: '#坂本日常更新', heat: '4.9万讨论', icon: 'ri-sword-line' },
  { tag: '#我推的孩子完结', heat: '4.6万讨论', icon: 'ri-star-line' },
  { tag: '#漫画推荐', heat: '12.3万讨论', icon: 'ri-thumb-up-line', accent: true },
  { tag: '#追更打卡', heat: '10.1万讨论', icon: 'ri-calendar-check-line' },
  { tag: '#免费漫画', heat: '8.9万讨论', icon: 'ri-bookmark-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            热议话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            漫迷们正在热烈讨论的连载漫画与最新漫画更新话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((t) => (
            <a
              key={t.tag}
              href="#comments"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all hover:scale-105 ${
                t.accent
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${t.icon} text-sm`}></i>
              </span>
              <span className="text-sm font-medium whitespace-nowrap">{t.tag}</span>
              <span className="text-[11px] opacity-60">{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}